import React from 'react';
import type { IconProps } from '../types';

export const ChevronClosed = (props: IconProps) => () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="icon-diamond-right"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        opacity="0.2"
        x="0"
        y="0"
        width="24"
        height="24"
        rx="4"
      />
      <polygon
        id="Diamond"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        points="12 7 17 12 12 17 7 12"
      />
    </g>
  </svg>
);

export default ChevronClosed;
